export default __webpack_public_path__ + "static/media/logo512.df50f889.png";